import React from 'react';

const ExpertiseBlock = () => (
    <div className="block-item block-item--expertise clearfix">
        <h2 className="block-item__title large--three-twelfths">Expertise</h2>

        <div className="block-item__inner large--nine-twelfths">
            <div className="block-item__content">
                <p>We design websites that will interact comfortably with human. We hate the fact that screens win over real interaction with human nowadays, so we give you design that will blend with your natural taste and aesthetic, not against them. And most importantly, makes your customers like you even more.</p>
            </div>

            <div className="block-item__footer">
                <div className="grid">
                    <div className="grid__item bullet-list medium--one-half large--one-half">
                        <h3 className="bullet-list__title">Capability</h3>
                        <div className="bullet-list__inner">
                            <ul>
                                <li>Web Architecture</li>
                                <li>User Experience Design</li>
                                <li>User Interface Design</li>
                                <li>Graphic Design</li>
                                <li>Website Development</li>
                            </ul>
                        </div>
                    </div>
                    <div className="grid__item bullet-list medium--one-half large--one-half">
                        <h3 className="bullet-list__title">Product</h3>
                        <div className="bullet-list__inner">
                            <ul>
                                <li>Website and Microsite</li>
                                <li>E-Commerce Website</li>
                                <li>Interactive Infographic</li>
                                <li>Mobile Application</li>
                                <li>Graphic Design Content</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default ExpertiseBlock;



// WEBPACK FOOTER //
// ./src/containers/About/ExpertiseBlock.js